

import { Component, ContentChild, ElementRef, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { TableViewComponentBase, TableViewFilter } from './table-view-component-base';
import { FILTER_MODE_DESCRIPTIONS, FilterFieldConfigBase, FilterableField as FilterableField } from '../filter-field-config/filter-field-config.component';
import { FilterFieldMode } from '../../directives/filter-field.directive';
import { BsModalService } from 'ngx-bootstrap/modal';
import { showFilterDetailModal } from '../filter-detail-modal/filter-detail-modal.component';


@Component({
  selector: 'fes-table-view-filter-input',
  styles: [
    '.invalid-filter { border: 3px solid red; color: red; }',
    'input::placeholder { color: gainsboro; font-style: italic; font-size: small;}'],
  template: `<input type="text" #filterInput class="w-100"
    [(ngModel)]="filter.value"
    (change)="valueChange$.emit(filter)"
    (keyup)="validateFilter(filter);keyUp$.emit({event:$event,filter:filter})"
    (dblclick)="!disabled&&modalEditFn&&modalEditFn()"
    [ngClass]="{'invalid-filter': !!filter.validationError}"
    [ngClass]="cssClass"
    [ngStyle]="filter.validationError?null:modeStyles[filter.mode]||defaultModeStyle"
    [title]="filter.validationError||modeDescriptions[filter.mode]"
    [placeholder]="filterEditFn||filter.mode!='contains'?'':filter.mode"
    [disabled]="disabled"/>`
})
export class TableViewFilterInputComponent implements FilterableField {
  @Input() filter: TableViewFilter;
  @Input() enableModeChange: boolean = false
  @Input() disabled = false
  @Input() filterEditFn?: (newValSetter?:(newVal:string)=>void) => Promise<boolean>;
  @Input() modalEditFn?: () => Promise<void>;
  @Input() cssClass?: string;
  @Output('valueChange') valueChange$ = new EventEmitter<TableViewFilter>()
  @Output('modeChange') modeChange$ = new EventEmitter<FilterFieldMode>()
  @Output('keyUp') keyUp$ = new EventEmitter<{event:KeyboardEvent,filter:TableViewFilter}>()

  @ViewChild('filterInput') htmlInputRef: ElementRef<HTMLInputElement>;

  modeStyles = {
    'contains': {},
    '=': { 'background-color': 'LightYellow' }
  }
  modeDescriptions = FILTER_MODE_DESCRIPTIONS;
  
  defaultModeStyle = {
    'background-color': 'LemonChiffon'
  }

  inputClass?: string;

  constructor(public elementRef: ElementRef) {
  }

  ////////////////////////////////////////////////
  //
  // BEGIN FilterableField implementation
  //
  getNativeInputElement(): HTMLInputElement | null {
    return this.htmlInputRef.nativeElement;
  }
  
  get mode() {
    return this.filter?.mode;
  }

  setMode(mode:FilterFieldMode){
    if ( this.filter ) {
      this.filter.mode = mode;
    }
  }
  //
  // END FilterableField
  //
  ////////////////////////////////////////////////

  validateFilter = (fieldFilter: TableViewFilter) => {
    delete fieldFilter.validationError
    if ( fieldFilter.mode == '~*' ) {
      try {
        new RegExp(fieldFilter.value);
      } catch (e) {
        fieldFilter.validationError = 'Invalid regular expression (filter mode is regex)'
      }
    }
  }

}

// provides the drop down menu for changing filter mode
@Component({
  selector: 'fes-table-view-filter-input-dropdown',
  templateUrl: '../filter-field-config/filter-field-config.component.html',
  styleUrls: ['../filter-field-config/filter-field-config.component.css']
})
export class TableViewFilterInputDropdownComponent extends FilterFieldConfigBase {

  @Input() title: string;
  @Input() table: TableViewComponentBase<any>;

  @ContentChild(TableViewFilterInputComponent) set filterFieldSet(filterInput: TableViewFilterInputComponent){
    this.filterField = filterInput;
    filterInput.modalEditFn = this.modalEditFn;
  }

  constructor(public bsModalService: BsModalService, elementRef: ElementRef){
    super(elementRef);
  }
  
  modalEditFn = async () => {
    const filterField = this.filterField as TableViewFilterInputComponent;
    const filter = filterField.filter;
    const filterEditFn = filterField.filterEditFn;
    if ( filterEditFn ) {
      await filterEditFn();
      return;
    } else {
      const {cancelled,editedFilter} = await showFilterDetailModal(this.bsModalService, {
        title: this.title || filter.key,
        filter
      });
      if ( cancelled ) {
        return;
      }
      const bModeChanged = filter.mode != editedFilter.mode;
      filter.mode = editedFilter.mode;
      filter.value = editedFilter.value;      
      if ( bModeChanged ) {
        this.handleModeChange(filter.mode);
      }
      this.onLostFocus();
      this.modeNeedsInput = this.isTextInputMode(filter.mode)
      await this.table.load();
    }
  }

  
}

